// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sub-menu .v-tabs__bar {\n  background-color: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
